import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {MatButton} from '@angular/material/button';
import {MatFormField, MatLabel} from '@angular/material/form-field';
import {MatInput} from '@angular/material/input';
import {TranslateModule} from '@ngx-translate/core';
import {MatCheckbox} from '@angular/material/checkbox';
import {CantaaMessageService} from '../../../service/cantaa-message.service';
import {KeycloakUserService} from '../../../service/keycloak/keycloak-user.service';
import {KeycloakUser} from '../../../model/keycloak/keycloak-user.model';
import {CantaaErrorHandlerService} from '../../../service/cantaa-error-handler.service';

@Component({
  selector: 'wim-user-detail',
  standalone: true,
  imports: [
    FormsModule,
    MatButton,
    MatFormField,
    MatInput,
    MatLabel,
    ReactiveFormsModule,
    TranslateModule,
    MatCheckbox
  ],
  templateUrl: './user-detail.component.html',
  styleUrl: './user-detail.component.scss'
})
export class UserDetailComponent implements OnInit {

  detailForm = this.fb.group({
    userId: { value: '', disabled: true },
    userName: { value: '', disabled: true },
    firstName: '',
    lastName: '',
    email: '',
    enabled: false,
    password: ''
  });

  constructor(private fb: FormBuilder,
              private keycloakUserService: KeycloakUserService,
              private messageService: CantaaMessageService,
              private router: Router,
              private route: ActivatedRoute,
              private errorHandler: CantaaErrorHandlerService) {
  }

  async ngOnInit() {
    const userId = this.route.snapshot.paramMap.get('userId');
    console.log(userId);
    if (userId === 'new' || userId === null) {
      this.detailForm.get('userName')?.enable();
    } else {
      try {
        await this.fetchKeycloakUser(userId);
      } catch (e) {
        this.errorHandler.handleError(e, 'FAILED_TO_FETCH');
        throw e;
      }
    }
  }

  private async fetchKeycloakUser(userKeycloakId: string | null) {
    const keycloakUser = await this.keycloakUserService.getKeycloakUser(userKeycloakId!);

    this.detailForm.setValue(
      {
        userId: keycloakUser.keycloakId,
        userName: keycloakUser.username,
        firstName: keycloakUser.firstName,
        lastName: keycloakUser.lastName,
        email: keycloakUser.email,
        enabled: keycloakUser.enabled,
        password: keycloakUser.password,
      });
  }

  async onSave() {
    const userId = this.detailForm.getRawValue().userId;
    const user = {
      keycloakId: userId,
      userId: userId,
      username: this.detailForm.value.userName,
      firstName: this.detailForm.value.firstName,
      lastName: this.detailForm.value.lastName,
      email: this.detailForm.value.email,
      enabled: this.detailForm.value.enabled,
      password: this.detailForm.value.password,
      keycloakOrganizationId: 'any',
    } as KeycloakUser;

    try {
      const savedUser = await this.keycloakUserService.saveKeycloakUser(user);
      if (!user.keycloakId) {
        // edit roles after saving a new user
        this.messageService.success("CREATE.SUCCESS");
        await this.router.navigate(['../', savedUser.keycloakId], { relativeTo: this.route, queryParams: { tab: 1 } });
      } else {
        // navigate to list after editing existing user
        this.messageService.success("UPDATE.SUCCESS");
        await this.navigateToUserList();
      }
    } catch (e) {
      this.errorHandler.handleError(e, 'UPDATE.FAILED');
      throw e;
    }
  }

  async onCancel() {
    await this.navigateToUserList();
  }

  private async navigateToUserList() {
    await this.router.navigate(['../'], { relativeTo: this.route });
  }

}
